export enum FilterType {
    Dropdown = 'Dropdown',
    MultiSelect = 'MultiSelect',
    DateRange = 'DateRange',
    DatePicker = 'DatePicker',
    Toggle = 'Toggle',
    TextInput = 'TextInput'
}
